<template>
  <div class="flex justify-start cols-6 gap-3 flex-wrap md:columns-3">

    <div class="w-full" v-if="initialLoading">
       <block-loading />
    </div>
   
    <template v-else>
      <div :class="'border hover:bg-theme-green-300 rounded-lg p-4 w-[164px] mt-2' + (activeItemObject.id == item.id ? ' bg-theme-green-300 border-theme-green' : ' bg-theme-grey border-theme-green')" v-bind:key="'location_pos_station' + item.id" v-for="item in locationPosList">
        <div @click.prevent="setActiveItem(item)" class="cursor-pointer">
                  
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7009 4.09775C15.6196 4.43891 14.7852 5.34957 14.5269 6.47034C14.4347 6.87023 14.401 17.5607 14.4908 17.896C14.5729 18.2025 14.93 18.3282 15.7191 18.3282H16.4283L16.4287 12.4182C16.4289 6.70666 16.4344 6.49946 16.5906 6.24324C16.9426 5.66593 16.8349 5.68161 20.634 5.6539L24.0594 5.62885V11.9799V18.3309L26.2367 18.3088L28.4141 18.2867L28.4353 11.9527L28.4566 5.61873L28.85 5.67597C29.3089 5.74282 29.5573 5.88433 29.7608 6.19471C29.896 6.40125 29.9102 6.86392 29.9486 12.3523L29.99 18.2867H30.8062C32.0723 18.2867 31.9491 18.9646 31.9212 12.1569L31.8978 6.42539L31.7053 5.94869C31.4366 5.28338 30.8138 4.62794 30.1305 4.29151L29.5789 4.01995L23.3147 4.00369C18.2986 3.99075 16.9807 4.0095 16.7009 4.09775ZM12.3021 14.8826C11.4481 15.1494 10.6861 15.8433 10.2603 16.742L10 17.2913V29.4015V41.5116L10.2648 42.0708C10.6077 42.7944 11.2056 43.3923 11.9292 43.7352L12.4884 44H23.1928H33.8971L34.5239 43.6902C35.2788 43.3171 35.7491 42.8368 36.1144 42.0657L36.3769 41.5116V29.3583V17.2049L36.1086 16.66C35.6771 15.7835 34.7448 15.0233 33.8263 14.7991L33.5982 14.7435V16.7044C33.5982 19.0987 33.5281 19.3506 32.7513 19.747C32.4548 19.8984 32.1061 19.9041 23.1665 19.9041H13.8895L13.5148 19.6665C12.8634 19.2534 12.8242 19.096 12.7941 16.7729C12.7798 15.6666 12.7424 14.764 12.7112 14.767C12.6799 14.7701 12.4958 14.8221 12.3021 14.8826ZM30.6189 22.7878L30.861 23.0587V24.5845V26.1103L30.6057 26.3251L30.3506 26.5398H23.1867H16.0229L15.7901 26.3398L15.5574 26.1398L15.5317 24.6154C15.5073 23.1667 15.5148 23.0799 15.6821 22.8672C15.7789 22.7441 15.9771 22.6086 16.1225 22.566C16.2787 22.5203 19.2495 22.4944 23.3819 22.5028L30.377 22.5169L30.6189 22.7878ZM17.6297 28.2085C18.3266 28.402 18.7497 28.9635 18.7504 29.6959C18.7516 30.9915 17.241 31.7051 16.2544 30.875C15.7493 30.4501 15.5484 29.6665 15.796 29.0878C15.9485 28.7314 16.3374 28.3773 16.73 28.2373C17.1257 28.0962 17.2152 28.0934 17.6297 28.2085ZM23.6018 28.2085C24.2922 28.4001 24.7219 28.9644 24.7225 29.6805C24.7238 30.9922 23.2207 31.7116 22.2265 30.875C21.7215 30.4501 21.5206 29.6665 21.7682 29.0878C21.9206 28.7314 22.3095 28.3773 22.7021 28.2373C23.0979 28.0962 23.1873 28.0934 23.6018 28.2085ZM29.574 28.2085C30.2643 28.4001 30.694 28.9644 30.6947 29.6805C30.6959 30.9922 29.1928 31.7116 28.1986 30.875C27.6936 30.4501 27.4927 29.6665 27.7403 29.0878C27.8927 28.7314 28.2817 28.3773 28.6743 28.2373C29.07 28.0962 29.1594 28.0934 29.574 28.2085ZM17.8173 32.9713C18.4072 33.2177 18.7508 33.7355 18.7508 34.3776C18.7508 34.8794 18.5923 35.2357 18.2258 35.5574C17.4709 36.2203 16.2376 35.9426 15.8285 35.0177C15.2672 33.7489 16.5411 32.4381 17.8173 32.9713ZM23.7895 32.9713C24.3793 33.2177 24.7229 33.7355 24.7229 34.3776C24.7229 34.8794 24.5644 35.2357 24.1979 35.5574C23.443 36.2203 22.2098 35.9426 21.8006 35.0177C21.2394 33.7489 22.5133 32.4381 23.7895 32.9713ZM29.7616 32.9713C30.3514 33.2177 30.6951 33.7355 30.6951 34.3776C30.6951 34.8794 30.5366 35.2357 30.17 35.5574C29.4151 36.2203 28.1819 35.9426 27.7727 35.0177C27.2115 33.7489 28.4854 32.4381 29.7616 32.9713ZM18.1394 37.8693C18.6105 38.2505 18.766 38.5999 18.7317 39.1999C18.7089 39.5998 18.6537 39.7726 18.4731 40.0094C17.8191 40.8669 16.5347 40.8421 15.9515 39.9608C15.7647 39.6785 15.7233 39.5235 15.7233 39.1062C15.7233 38.1393 16.3772 37.5355 17.3602 37.5948C17.7382 37.6176 17.8982 37.674 18.1394 37.8693ZM24.1115 37.8693C24.5826 38.2505 24.7381 38.5999 24.7039 39.1999C24.6811 39.5998 24.6258 39.7726 24.4452 40.0094C23.7912 40.8669 22.5069 40.8421 21.9236 39.9608C21.7368 39.6785 21.6954 39.5235 21.6954 39.1062C21.6954 38.1393 22.3494 37.5355 23.3324 37.5948C23.7103 37.6176 23.8703 37.674 24.1115 37.8693ZM30.0837 37.8693C30.5547 38.2505 30.7102 38.5999 30.676 39.1999C30.6532 39.5998 30.5979 39.7726 30.4174 40.0094C29.7633 40.8669 28.479 40.8421 27.8957 39.9608C27.7089 39.6785 27.6675 39.5235 27.6675 39.1062C27.6675 38.1393 28.3215 37.5355 29.3045 37.5948C29.6825 37.6176 29.8425 37.674 30.0837 37.8693Z" fill="white"/>
        </svg>

          <h2 class="font-semibold text-sm h-[50px] pt-3 leading-4 capitalize">{{ item.processor }}</h2>
        </div>
        <span class="mb-0 text-sm">Status</span>
        <label class="flex items-center cursor-pointer" :for="'pos_status_'+item.id" @click.prevent="openConfirmStatusModal(item)">
          <input type="checkbox" :id="'pos_status_'+item.id" v-model="item.active" class="hidden peer">
          <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (item.active ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
          <span class="ml-2 text-white text-sm font-medium uppercase" :class="item.active ? 'text-theme-green' : 'text-[#F53333]'">{{item.active ? 'ON' : 'OFF'}}</span>
        </label>
      </div>

      <div :class="'border rounded-lg p-4 w-[164px] mt-2  ' + (iscomponentactive ? ' disabled-box border-theme-878686' : 'cursor-pointer bg-theme-grey hover:bg-theme-green-300 border-theme-green')">
        <div @click="iscomponentactive ? void(0) : addComponent()" class=" items-center justify-between flex flex-col h-full">
          <p class="font-semibold text-sm text-theme-878686">Add New Device</p>
                
            <svg width="64" height="64" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M37.8586 83.6693V46.4669H0.65625V37.5383H37.8586V0.335938H46.7872V37.5383H83.9896V46.4669H46.7872V83.6693H37.8586Z" :fill="iscomponentactive ? '#878686' : '#2BA66B'"/>
            </svg>
          <p :class="'font-semibold text-sm leading-4 capitalize mt-2 ' + (iscomponentactive ? 'text-theme-878686' : 'text-theme-green')">+ ADD</p>
        </div>
     
      </div>

    </template>

   <ReturnConfirmModal v-if="confirmStatusObj.modal" :obj="confirmStatusObj.obj" :closeClick="closeConfirmStatusModal" :actionClick="togglePosStatus" :heading="'You Are About To Update ' + confirmStatusObj.obj.processor "/>

  </div>
</template>


<script lang="ts">
import  { defineComponent , ref} from "vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import LocationPaymentProcessorApis from "@/controllers/LocationPaymentProcessorApis";
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';
import ReturnConfirmModal from "@/components/general/dialog/ReturnConfirmModal.vue";

export default defineComponent({
  components: {
    ReturnConfirmModal,
  },
  props: {
    iscomponentactive: {
      type: Boolean,
      required: false,
    },
    selectedItemCallback: {
      type: Function,
      required: true,
    },
    clearComponent: {
      type: Function,
      required: true,
    },
    addComponent: {
      type: Function,
      required: true,
    },
    
  },
  setup() {
    const confirmStatusObj = ref({
      modal: false,
      obj: {},
    });
    const activeItemObject = ref<any>({});
    const initialLoading = ref<Boolean>(false);
    const locationPosList = ref([]);
    const snackbar = useSnackbar();
    return  {
      activeItemObject,
      initialLoading,
      confirmStatusObj,
      locationPosList,
      snackbar
    };
  },

  async mounted() {
    this.initialLoading = true;
    await this.fetchList();
    this.initialLoading = false;
    this.emitter.on("refresh-location-payment-processor-list", data => {
      this.fetchList();
    });
    this.emitter.on("reset-location-payment-processor-component", data => {
      this.activeItemObject = {};
    });
  },

  beforeDestroy() {
    this.emitter.off('refresh-location-payment-processor-list', () => {});
    this.emitter.off('reset-location-payment-processor-component', () => {});
  },

  watch: {
    'vg_selectedLocation': async function (val) {
      // if location selected is changed fetch the data
      this.initialLoading = true;
      await this.fetchList();
      this.initialLoading = false;
    },
  },

  computed: {
    ...mapGetters({
      vg_selectedLocation: 'location/selected'
    }),
  },

  methods: {
    /**
     * Fetch list
     */
    async fetchList() {
      let res = await LocationPaymentProcessorApis.fetchAll();  
      if(res.status == 200) {
        this.locationPosList = res.data.payload;
      }
    },

    /**
     * Set active
     */
    setActiveItem(item) {
      this.activeItemObject = item;
      this.selectedItemCallback(item);
    },
    /**
     * Close Confirm status modal
     */
    closeConfirmStatusModal() {
      this.confirmStatusObj = {
        modal: false,
        obj: {},
      };
    },
    /**
     * Open confirm satus modal
     */
    openConfirmStatusModal(obj) {
      this.confirmStatusObj = {
        modal: true,
        obj,
      };
    },

     /**
     * Toggle business status
     */
    async togglePosStatus(obj) {

      this.va_spinner(true);
      let res = await LocationPaymentProcessorApis.update(obj.id, {
        active: obj.active ? false : true,
      });
      this.va_spinner(false);
        this.snackbar.add({
        type: 'info',
        text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
      if(res.status == 200 ) {
        this.closeConfirmStatusModal();
        this.clearComponent();
        this.emitter.emit("refresh-location-payment-processor-list", true);
      }
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
    })
    
  }
});
</script>

